 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		16: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		16: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"4b09a343b16d75b3607a2cd50f1113f8084bbcb7","2":"c16184b3","3":"2cca2479","4":"d9b509b06ff450faaf9349d6b790a4aac3fc5176","5":"99f6520f5c54f0df3374eb5afce358cfcf39690c","6":"91f8d01865a44d1f7a0248f9bd2a57ef68875b94","7":"13532cc13a46f88bbfb71520da73e975fc8bc753","8":"f357f4e3","9":"dfb3b8c9fcf7d8ee838ae750a4ce65dcea15d88a","10":"c80e3de89acda53578dbcabc81f8c5c0db65e3e1","11":"f95b3cc095fe0b523e567bda2979e3b66652f69e","12":"27a524f8bafb971eabe973554f818691b6ef19f2","13":"9ff62e881f1048a32e72e478d1442f6fa5bd0f78","14":"f03c42fb882a5cdb86cf032975c22f5479c11d68","15":"framework","18":"component---cache-caches-gatsby-plugin-offline-app-shell-js","19":"component---src-pages-404-jsx","20":"component---src-pages-akcesorium-jsx","21":"component---src-pages-artykul-jsx","22":"component---src-pages-artykuly-jsx","23":"component---src-pages-certyfikaty-jsx","24":"component---src-pages-do-pobrania-jsx","25":"component---src-pages-drzwi-jsx","26":"component---src-pages-drzwi-na-wymiar-jsx","27":"component---src-pages-faq-jsx","28":"component---src-pages-gdzie-kupic-jsx","29":"component---src-pages-historia-jsx","30":"component---src-pages-index-jsx","31":"component---src-pages-instagram-feed-jsx","32":"component---src-pages-inwestycje-jsx","33":"component---src-pages-jakosc-jsx","34":"component---src-pages-katalogi-jsx","35":"component---src-pages-kontakt-jsx","36":"component---src-pages-optimo-jsx","37":"component---src-pages-premium-jsx","38":"component---src-pages-produkty-jsx","39":"component---src-pages-realizacje-jsx","40":"component---src-pages-reklamacje-jsx","41":"component---src-pages-smart-jsx","42":"component---src-pages-technologie-jsx","43":"component---src-pages-ulubione-jsx","44":"component---src-pages-wszystko-o-drzwiach-jsx","45":"component---src-pages-wyszukiwarka-jsx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"60dd73862ee3871267c3","2":"70db5c57d10916b23e31","3":"9691909f804ab538dfeb","4":"62dd34f573ddebcbd4e2","5":"82a3a9c6dea5b0cf1034","6":"0c7e6f2fdd7565c3932e","7":"ccb2dbbf267c2b6df2b5","8":"3c48c9b33682a2ea5e3c","9":"1ec6e426b88f02e22f01","10":"31a2700b6a702f4989cd","11":"b2d15db163a04f658d9a","12":"43fea124c68557386132","13":"c6ee79333196fccae194","14":"98d34fcbda6d35859ecf","15":"8ef1a4514016b2038b2a","18":"705bea9ad1fc6717a905","19":"2ef16cc7cb104c289e8a","20":"5632647627be139b9b83","21":"249c812719d3624833c4","22":"bfa5f701c9856502b640","23":"1064f8657f7d4f6c6ed0","24":"ada5ab0fa77dca594cd0","25":"7454f91cb97bdb3d7881","26":"e6f7b532d11fd89e83b9","27":"fa944f67a1272f4c4edb","28":"415606c7556821e7adfa","29":"e537aa7c515c727fddc1","30":"607ed5652bd901954bfe","31":"bd33935daaf8f0a7b92e","32":"fa8b49c889db5f0f74d8","33":"378ad338293529a75440","34":"c690e7f34b9ff1ba560c","35":"f8227ced6389bbc385f2","36":"4f09ea570d2242473b73","37":"d2209285c73599bef02d","38":"14fd7fbf664026c0e510","39":"a12e5b46404650c29f88","40":"1188f3c575e30ceb2467","41":"c7cb07aaf5496ad88188","42":"bd791439e5cca320cdde","43":"48be6a7323534ad210be","44":"3e83febc6c40b72bd400","45":"53e4cda7d74531bf0219"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"4b09a343b16d75b3607a2cd50f1113f8084bbcb7","2":"c16184b3","3":"2cca2479","4":"d9b509b06ff450faaf9349d6b790a4aac3fc5176","5":"99f6520f5c54f0df3374eb5afce358cfcf39690c","6":"91f8d01865a44d1f7a0248f9bd2a57ef68875b94","7":"13532cc13a46f88bbfb71520da73e975fc8bc753","8":"f357f4e3","9":"dfb3b8c9fcf7d8ee838ae750a4ce65dcea15d88a","10":"c80e3de89acda53578dbcabc81f8c5c0db65e3e1","11":"f95b3cc095fe0b523e567bda2979e3b66652f69e","12":"27a524f8bafb971eabe973554f818691b6ef19f2","13":"9ff62e881f1048a32e72e478d1442f6fa5bd0f78","14":"f03c42fb882a5cdb86cf032975c22f5479c11d68","15":"framework","18":"component---cache-caches-gatsby-plugin-offline-app-shell-js","19":"component---src-pages-404-jsx","20":"component---src-pages-akcesorium-jsx","21":"component---src-pages-artykul-jsx","22":"component---src-pages-artykuly-jsx","23":"component---src-pages-certyfikaty-jsx","24":"component---src-pages-do-pobrania-jsx","25":"component---src-pages-drzwi-jsx","26":"component---src-pages-drzwi-na-wymiar-jsx","27":"component---src-pages-faq-jsx","28":"component---src-pages-gdzie-kupic-jsx","29":"component---src-pages-historia-jsx","30":"component---src-pages-index-jsx","31":"component---src-pages-instagram-feed-jsx","32":"component---src-pages-inwestycje-jsx","33":"component---src-pages-jakosc-jsx","34":"component---src-pages-katalogi-jsx","35":"component---src-pages-kontakt-jsx","36":"component---src-pages-optimo-jsx","37":"component---src-pages-premium-jsx","38":"component---src-pages-produkty-jsx","39":"component---src-pages-realizacje-jsx","40":"component---src-pages-reklamacje-jsx","41":"component---src-pages-smart-jsx","42":"component---src-pages-technologie-jsx","43":"component---src-pages-ulubione-jsx","44":"component---src-pages-wszystko-o-drzwiach-jsx","45":"component---src-pages-wyszukiwarka-jsx"}[chunkId]||chunkId) + "." + {"0":"080e24c558fea3c73f87","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
